import { CKSelectableItem, CKSelectNext } from 'clearkit';
import React, { FC } from 'react';

type MembershipSelectProps = {
  hasBasicPermissions: boolean;
  isDisabled?: boolean;
  value: CKSelectableItem;
  onChange: (value: CKSelectableItem) => void;
};

export const baseSelectRoles = [
  {
    value: 'owner',
    label: 'Admin',
  },
  {
    value: 'user',
    label: 'Member',
  },
];

export const flaggedRoles = {
  value: 'ops',
  label: 'User (Ops)',
};

export const memberSelectRoles = [
  ...baseSelectRoles,
  flaggedRoles,
] as CKSelectableItem[];

export const MembershipSelect: FC<MembershipSelectProps> = ({
  isDisabled,
  hasBasicPermissions,
  onChange,
  value,
}) => {
  const roles = hasBasicPermissions ? memberSelectRoles : baseSelectRoles;

  return (
    <CKSelectNext
      className="max-w-[12rem]"
      isDisabled={isDisabled}
      items={roles}
      onChange={onChange}
      placeholder="Select role"
      value={value}
    />
  );
};
